import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import OfferBanner from '../OfferBanner';
export const MonetizationStrip = ({ className , deviation , onAdoptableSaleEnd  })=>{
    var _deviation_extended, _deviation_extended_adoptable, _deviation_adoptable, _deviation_adoptable1, _deviation_extended1;
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const adoptables = useFlag('adoptables');
    const isAdoptsPromosFlagEnabled = useFlag('adopts_promos');
    const offers = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.offers;
    const showOfferBanner = offers && (((_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.status) === 'onsale' || ((_deviation_adoptable1 = deviation.adoptable) === null || _deviation_adoptable1 === void 0 ? void 0 : _deviation_adoptable1.status) === 'pending');
    if (adoptables && showOfferBanner) {
        return /*#__PURE__*/ React.createElement(OfferBanner, _extends({}, offers, {
            className: className,
            ownOffer: offers === null || offers === void 0 ? void 0 : offers.ownOffer,
            deviation: deviation,
            onEnd: onAdoptableSaleEnd
        }));
    }
    // dont show Monetization Strip on mobile
    if (isMobile) {
        return null;
    }
    const promo = deviation === null || deviation === void 0 ? void 0 : (_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.showStageMonetizationPromo;
    if (!promo || ![
        'tier',
        'commission',
        'premium_gallery',
        'adoptable'
    ].includes(promo) || !deviation.author || promo === 'adoptable' && !isAdoptsPromosFlagEnabled) {
        return null;
    }
    let biEvid = null;
    let link = '';
    if (promo === 'tier') {
        biEvid = BiEventType.VIEW_SUBSCRIPTION_TAB;
        link = Url.userSubscriptionsPath({
            username: deviation.author.username
        });
    } else if (promo === 'adoptable') {
        biEvid = BiEventType.VIEW_ADOPTABLES_TAB;
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.ADOPTABLES);
    } else if (promo === 'commission') {
        biEvid = BiEventType.VIEW_COMMISSIONS_TAB;
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS);
    } else if (promo === 'premium_gallery') {
        biEvid = BiEventType.VIEW_PREMIUM_GALLERIES_TAB;
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS);
    }
    return /*#__PURE__*/ React.createElement(PromoBanner, {
        className: className,
        size: "small",
        variant: "subscription",
        icon: /*#__PURE__*/ React.createElement(PromoBadge, {
            badgeType: promo,
            size: 16
        }),
        messageAfterIcon: t(`deviationview.artstage.monetizationStrip.var.${promo}.body`),
        ctaLabel: t(`deviationview.artstage.monetizationStrip.var.${promo}.CTA`),
        ctaHref: link,
        ctaBiData: biEvid ? {
            evid: biEvid,
            typeid: deviation.typeId,
            itemid: deviation.deviationId,
            referral_info: ReferralType.ART_STAGE_PROMOTION
        } : undefined
    });
};
MonetizationStrip.displayName = 'MonetizationStrip';
export default MonetizationStrip;
